import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { trackLegacyEvent } from 'helpers/analytics';
import ImageCarousel from 'components/common/ImageCarousel';
import ImageLazyLoader from 'components/common/ImageLazyLoader';
import DesktopImageCarousel from 'components/productdetail/DesktopImageCarousel';

import css from 'styles/components/productdetail/productImages.scss';

export class ProductImages extends Component {
  state = { currentSlide: (+this.props.carouselIndex) || 0 };

  onImageChange = currentSlide => {
    trackLegacyEvent('Product-Page', 'PrImage', 'Thumbnail-Swap-Click');
    this.setState({ currentSlide });
  };

  makeImage = (src, shouldStartLoading, shouldForceLoad) => {
    const imgProps = {
      'data-track-action': 'Product-Page',
      'data-track-label': 'Zoom-In',
      'data-track-value': 'Image-Click',
      'alt': 'Product View',
      'data-test-id': 'mobileProductImageDetails',
      src
    };
    return <ImageLazyLoader
      imgProps={imgProps}
      shouldStartLoading={shouldStartLoading}
      forceLoad={shouldForceLoad}
    />;
  };

  makeImageCarousel = (images, videos) => {
    const {
      carouselIndex, productStyles, productType, style, styleThumbnails,
      onStyleChange, onThumbnailClick, onProductImageClick, isYouTubeVideo,
      youtubeSrc, makeSpotlight, isSpotlightActive
    } = this.props;
    const slideIndex = parseInt(carouselIndex, 10);
    if (images && images.length > 0) {
      return (
        <div>
          <div className={css.mobileCarousel}>
            <ImageCarousel
              slidesToShow={1}
              slideIndex={slideIndex}
              slidesToScroll={1}
              autoplay={false}
              afterSlide={this.onImageChange}>
              {images.filter(({ type }) => type !== 'SWATCH').map(this.makeImageLink)}
            </ImageCarousel>
          </div>
          <div className={css.desktopCarousel}>
            <DesktopImageCarousel
              videos={videos}
              productStyles={productStyles}
              productType={productType}
              style={style}
              styleThumbnails={styleThumbnails}
              onStyleChange={onStyleChange}
              onThumbnailClick={onThumbnailClick}
              isYouTubeVideo={isYouTubeVideo}
              youtubeSrc={youtubeSrc}
              onProductImageClick={onProductImageClick}
              makeSpotlight={makeSpotlight}
              isSpotlightActive={isSpotlightActive} />
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  makeImageLink = ({ filename }, index) => {
    const {
      props: { productId, colorId, styleId },
      state: { currentSlide },
      makeImage
    } = this;
    return (
      <div key={index}>
        <Link to={`/i/${productId}${colorId ? `/color/${colorId}` : ''}/style/${styleId}/${index}`} data-test-id={this.context.testId('productImageLink')}>
          {makeImage(filename, index === currentSlide, index === 0)}
        </Link>
      </div>
    );
  };

  render() {
    const { images, videos } = this.props;
    const imageMicroFormat = images && images.length > 0 ? <meta itemProp="image" content={images[0].filename}/> : null;
    return (
      <div className={css.productImages} data-test-id={this.context.testId('productImages')}>
        {imageMicroFormat}
        {this.makeImageCarousel(images, videos)}
      </div>
    );
  }
}

ProductImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    filename: PropTypes.string.isRequired
  })),
  videos: PropTypes.array,
  productStyles: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  onStyleChange: PropTypes.func.isRequired
};

ProductImages.contextTypes = {
  testId: PropTypes.func
};

export default ProductImages;
